export default __webpack_public_path__ + "static/media/tick.c54fdae1.svg";